var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSync16Regular(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99997 2.5C6.35466 2.5 4.87737 3.22227 3.86883 4.36881L5.07322 5.5732C5.23071 5.73069 5.11917 5.99998 4.89645 5.99998H1.25C1.11193 5.99998 1 5.88805 1 5.74998V2.10353C1 1.8808 1.26929 1.76926 1.42678 1.92675L2.8066 3.30658C4.08696 1.89075 5.93912 1 7.99997 1C11.5822 1 14.5351 3.69021 14.9501 7.16094C14.9993 7.57222 14.7058 7.94551 14.2945 7.99469C13.8832 8.04388 13.5099 7.75034 13.4607 7.33906C13.1348 4.61345 10.8136 2.5 7.99997 2.5ZM1.70545 8.00531C2.11673 7.95612 2.49001 8.24966 2.5392 8.66094C2.86516 11.3865 5.18631 13.5 7.99997 13.5C9.6453 13.5 11.1226 12.7777 12.1311 11.6312L10.9268 10.4268C10.7693 10.2693 10.8808 10 11.1036 10H14.75C14.8881 10 15 10.112 15 10.25V13.8965C15 14.1192 14.7307 14.2307 14.5732 14.0732L13.1934 12.6934C11.913 14.1092 10.0608 15 7.99997 15C4.41771 15 1.46489 12.3098 1.04981 8.83906C1.00063 8.42778 1.29417 8.05449 1.70545 8.00531Z",
    fill: "#85919C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSync16Regular);
export default __webpack_public_path__ + "static/media/sync_16_regular.10693c391871a622852dc959dbf4342d.svg";
export { ForwardRef as ReactComponent };